export default "__VITE_ASSET__DflmKYIp__"